import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=5859e9aa&scoped=true&"
import script from "./ChatInput.vue?vue&type=script&lang=js&"
export * from "./ChatInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=5859e9aa&prod&lang=sass&"
import style1 from "./ChatInput.vue?vue&type=style&index=1&id=5859e9aa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859e9aa",
  null
  
)

export default component.exports